import { useMemo } from 'react';

import {
  createInitialValues,
  createValidationSchema,
} from 'components/NEFIComponents/NEFISteps/NEFIStepFormUpload/NEFIFormUploadIVFunctions';

export const useNEFIFormUploadIV = () => {
  return useMemo(() => {
    const initialValues = createInitialValues();
    const validationSchema = createValidationSchema();

    return {
      initialValues,
      validationSchema,
    };
  }, []);
};
